import createModule from "../createModule"
import view from "./view"
import { Creators } from "model/hookUpdater"
import { Creators as notificationsCreators } from "modules/notifications/model"

// `/pat-settings` ships with pi-server #2806, so a client deployed ahead of it gets a 404.
// Render nothing rather than an error block: an account whose server can't answer has no
// PAT setting to administer, which is what an absent card already means.
function NoCard() {
  return null
}

// Deliberately its own module rather than a second card inside account-settings: a
// createModule folds every resource in `data` into one status, so sharing one would mean a
// pat-settings failure blanks the sessions card too, and either card's `reloadData` would
// unmount the other mid-edit.
export default createModule({
  view,
  externalProps: (state) => ({
    account: state.global.selected.account,
  }),
  required: ["account"],
  data: [{
    resource: "patSettings",
    url: ({ account }) => `/api/${account}/pat-settings`,
  }],
  error: NoCard,
  actions: {
    ...notificationsCreators,
    ...Creators,
  },
})
